import React from 'react';
import { Button, Row, CardBody } from 'reactstrap';

import { LabelPosition, HandlePositionChange } from '../types';

type Props = {
  labelPosition: LabelPosition,
  onChange: HandlePositionChange,
};

const ModalMatrix4: React.FC<Props> = ({
  labelPosition,
  onChange,
}) => (
  <CardBody>
    <Row className="mb-2">
      <Button size="lg" className={labelPosition === 'first' ? 'active' : undefined} onClick={() => onChange('first')}>1</Button>
      <Button size="lg" className={labelPosition === 'second' ? 'active ml-2' : 'ml-2'} onClick={() => onChange('second')}>2</Button>
      <Button size="lg" className={labelPosition === 'third' ? 'active ml-2' : 'ml-2'} onClick={() => onChange('third')}>3</Button>
    </Row>
    <Row className="mb-2">
      <Button size="lg" className={labelPosition === 'fourth' ? 'active' : undefined} onClick={() => onChange('fourth')}>4</Button>
      <Button size="lg" className={labelPosition === 'fifth' ? 'active ml-2' : 'ml-2'} onClick={() => onChange('fifth')}>5</Button>
      <Button size="lg" className={labelPosition === 'sixth' ? 'active ml-2' : 'ml-2'} onClick={() => onChange('sixth')}>6</Button>
    </Row>
    <Row>
      <Button size="lg" className={labelPosition === 'seventh' ? 'active' : undefined} onClick={() => onChange('seventh')}>7</Button>
      <Button size="lg" className={labelPosition === 'eighth' ? 'active ml-2' : 'ml-2'} onClick={() => onChange('eighth')}>8</Button>
    </Row>
  </CardBody>
);

export default ModalMatrix4;
